(function () {
  var boot = document.getElementById("gwp-config");
  if (!boot) return;

  var cfg;
  try {
    cfg = JSON.parse(boot.textContent);
  } catch (e) {
    return;
  }

  var now = Date.now();
  if (now < Date.parse(cfg.start) || now > Date.parse(cfg.end)) return;
  if (!cfg.offer || !Array.isArray(cfg.tiers)) return;

  var tiers = cfg.tiers
    .filter(function (tier) {
      return tier.variant && tier.threshold > 0 && tier.available !== false;
    })
    .sort(function (a, b) {
      return a.threshold - b.threshold;
    });
  if (!tiers.length) return;

  var ATTRIBUTE = "_gwp";
  var GIFT_PROP = "_gwp_gift";
  var PRESENT_KEY = "ghia_gwp_present";
  var DISMISS_KEY = "ghia_gwp_dismissed";

  function readMap(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function writeMap(key, map) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(map));
    } catch (e) {}
  }

  function flag(key, variant, value) {
    var map = readMap(key);
    if (value) {
      map[String(variant)] = 1;
    } else {
      delete map[String(variant)];
    }
    writeMap(key, map);
  }

  function hasFlag(key, variant) {
    return Boolean(readMap(key)[String(variant)]);
  }

  function tierFor(variant) {
    for (var i = 0; i < tiers.length; i++) {
      if (String(tiers[i].variant) === String(variant)) return tiers[i];
    }
    return null;
  }

  function isGiftItem(item) {
    return Boolean(
      item && item.properties && item.properties[GIFT_PROP] === cfg.offer && tierFor(item.variant_id),
    );
  }

  function countsTowardSpend(item) {
    if (isGiftItem(item)) return false;
    if (item.selling_plan_allocation && !cfg.countSubscriptions) return false;
    return true;
  }

  function subtotalOf(cart, quantities) {
    return (cart.items || []).reduce(function (sum, item) {
      if (!countsTowardSpend(item)) return sum;
      var qty = quantities && quantities.hasOwnProperty(item.key) ? quantities[item.key] : item.quantity;
      return sum + (item.original_price || item.price || 0) * qty;
    }, 0);
  }

  function desiredFor(subtotal) {
    var qualified = tiers.filter(function (tier) {
      return subtotal >= tier.threshold * 100;
    });
    if (!cfg.stack && qualified.length > 1) qualified = [qualified[qualified.length - 1]];
    var desired = {};
    tiers.forEach(function (tier) {
      desired[String(tier.variant)] = 0;
    });
    qualified.forEach(function (tier) {
      desired[String(tier.variant)] = 1;
    });
    return desired;
  }

  function giftLines(cart) {
    var lines = {};
    (cart.items || []).forEach(function (item) {
      var key = String(item.variant_id);
      if (isGiftItem(item) && !lines[key]) lines[key] = item;
    });
    return lines;
  }

  function stateMatches(cart, desired) {
    var lines = giftLines(cart);
    return tiers.every(function (tier) {
      var key = String(tier.variant);
      var line = lines[key];
      var want = desired[key];
      if (line) return line.quantity === want;
      return want === 0 || hasFlag(DISMISS_KEY, key);
    });
  }

  function findLine(cart, ref) {
    var id = String(ref);
    for (var i = 0; i < (cart.items || []).length; i++) {
      var item = cart.items[i];
      if (item.key === id || String(item.variant_id) === id) return item;
    }
    return null;
  }

  var cartState = null;
  var giftRequestActive = false;
  var nativeFetch = window.fetch;

  function request(url, payload) {
    return nativeFetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });
  }

  function fetchCart() {
    return nativeFetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) {
      return r.json();
    });
  }

  function siteCart() {
    return document.querySelector("site-cart");
  }

  function sectionNames() {
    var el = siteCart();
    if (!el || typeof el.getCartSections !== "function") return null;
    return el.getCartSections().map(function (s) {
      return s.section;
    });
  }

  function renderSections(data) {
    var el = siteCart();
    if (el && data && data.sections) {
      el.renderCartSections(data.sections);
      el.handleRewards();
    }
  }

  function track(event, tier) {
    if (typeof window.ghiaTrack !== "function") return;
    window.ghiaTrack(event, { offer: cfg.offer, gift: tier.title, tier: tier.threshold });
  }

  function report(stage, error) {
    if (!window.ghiaReport) return;
    window.ghiaReport("cart_error", {
      error_message: error && error.message ? error.message : String(error),
      error_stage: stage,
    });
  }

  function reconcile(cart, desired, sections) {
    var lines = giftLines(cart);
    var removals = [];
    var additions = [];
    tiers.forEach(function (tier) {
      var key = String(tier.variant);
      var line = lines[key];
      var want = desired[key];
      if (line && line.quantity !== want) removals.push({ variant: key, quantity: want });
      if (!line && want > 0 && !hasFlag(DISMISS_KEY, key)) additions.push(tier);
    });
    if (!removals.length && !additions.length) return Promise.resolve(null);

    giftRequestActive = true;
    var last = null;
    var chain = Promise.resolve(cart);

    removals.forEach(function (removal, index) {
      chain = chain.then(function (latest) {
        var line = giftLines(latest)[removal.variant];
        if (!line) return latest;
        var payload = { id: line.key, quantity: removal.quantity };
        if (sections && !additions.length && index === removals.length - 1) payload.sections = sections;
        return request("/cart/change.js", payload).then(function (response) {
          if (!response.ok) return latest;
          return response.json().then(function (data) {
            if (removal.quantity === 0) flag(PRESENT_KEY, removal.variant, false);
            last = data;
            return data;
          });
        });
      });
    });

    if (additions.length) {
      chain = chain.then(function (latest) {
        var payload = {
          items: additions.map(function (tier) {
            var properties = {};
            properties[GIFT_PROP] = cfg.offer;
            return { id: tier.variant, quantity: 1, properties: properties };
          }),
        };
        if (sections) payload.sections = sections;
        return request("/cart/add.js", payload).then(function (response) {
          if (!response.ok) {
            additions.forEach(function (tier) {
              flag(DISMISS_KEY, tier.variant, true);
            });
            return response.json().then(function (data) {
              report("gwp_add_rejected", data && (data.description || data.message));
              return latest;
            });
          }
          return response.json().then(function (data) {
            additions.forEach(function (tier) {
              flag(PRESENT_KEY, tier.variant, true);
              track("gwp_unlocked", tier);
            });
            last = data;
            return latest;
          });
        });
      });
    }

    return chain
      .then(function () {
        giftRequestActive = false;
        return last;
      })
      .catch(function (error) {
        giftRequestActive = false;
        report("gwp_reconcile", error);
        return null;
      });
  }

  function ensureAttribute(cart, sections) {
    if (cart.attributes && cart.attributes[ATTRIBUTE] === cfg.offer) {
      return Promise.resolve({ cart: cart, data: null });
    }
    var attributes = {};
    attributes[ATTRIBUTE] = cfg.offer;
    var payload = { attributes: attributes };
    if (sections) payload.sections = sections;
    giftRequestActive = true;
    return request("/cart/update.js", payload)
      .then(function (response) {
        giftRequestActive = false;
        if (!response.ok) return { cart: cart, data: null };
        return response.json().then(function (data) {
          return { cart: data, data: data };
        });
      })
      .catch(function () {
        giftRequestActive = false;
        return { cart: cart, data: null };
      });
  }

  function noteDismissals(cart, desired) {
    var lines = giftLines(cart);
    tiers.forEach(function (tier) {
      var key = String(tier.variant);
      if (desired[key] === 0) {
        flag(DISMISS_KEY, key, false);
        flag(PRESENT_KEY, key, false);
        return;
      }
      if (lines[key]) {
        flag(PRESENT_KEY, key, true);
      } else if (hasFlag(PRESENT_KEY, key)) {
        flag(PRESENT_KEY, key, false);
        flag(DISMISS_KEY, key, true);
      }
    });
  }

  function responseWith(original, data) {
    return new Response(JSON.stringify(data), {
      status: original.status,
      headers: { "Content-Type": "application/json" },
    });
  }

  function parseBody(init) {
    if (!init || typeof init.body !== "string") return null;
    try {
      return JSON.parse(init.body);
    } catch (e) {
      return null;
    }
  }

  function interceptAdd(input, init) {
    var body = parseBody(init);
    if (!body) return nativeFetch(input, init);
    var items = Array.isArray(body.items) ? body.items : body.id ? [body] : [];
    var addsGift = items.some(function (item) {
      return item.properties && item.properties[GIFT_PROP];
    });
    if (addsGift) return nativeFetch(input, init);

    return nativeFetch(input, init).then(function (response) {
      if (!response.ok) return response;
      return response
        .clone()
        .json()
        .then(function (data) {
          return fetchCart().then(function (fetched) {
            var desired = desiredFor(subtotalOf(fetched));
            if (stateMatches(fetched, desired)) {
              cartState = fetched;
              return response;
            }
            return ensureAttribute(fetched, null).then(function (outcome) {
              var cart = outcome.cart;
              cartState = cart;
              var sections = Array.isArray(body.sections) ? body.sections : null;
              return reconcile(cart, desired, sections);
            }).then(function (result) {
              if (!result) return response;
              if (result.sections) data.sections = result.sections;
              return responseWith(response, data);
            });
          });
        })
        .catch(function () {
          return response;
        });
    });
  }

  function targetsGift(body, pathname) {
    if (!cartState) return null;
    if (pathname.indexOf("/cart/change") === 0) {
      var target = null;
      if (body.line !== undefined) {
        target = cartState.items[Number(body.line) - 1] || null;
      } else if (body.id !== undefined) {
        target = findLine(cartState, body.id);
      }
      return target && isGiftItem(target) ? [target] : false;
    }
    if (!body.updates || typeof body.updates !== "object") return false;
    var hits = [];
    Object.keys(body.updates).forEach(function (key) {
      var line = Array.isArray(body.updates) ? cartState.items[Number(key)] : findLine(cartState, key);
      if (line && isGiftItem(line)) hits.push(line);
    });
    return hits.length ? hits : false;
  }

  function interceptChange(input, init, pathname) {
    var body = parseBody(init);
    if (!body) return nativeFetch(input, init);

    var gifts = targetsGift(body, pathname);
    if (gifts === null) return nativeFetch(input, init);
    if (gifts) {
      gifts.forEach(function (line) {
        flag(DISMISS_KEY, line.variant_id, true);
        flag(PRESENT_KEY, line.variant_id, false);
      });
      return nativeFetch(input, init);
    }

    return nativeFetch(input, init).then(function (response) {
      if (!response.ok) return response;
      return response
        .clone()
        .json()
        .then(function (changed) {
          if (!changed || !Array.isArray(changed.items)) return response;
          cartState = changed;
          var desired = desiredFor(subtotalOf(changed));
          noteDismissals(changed, desired);
          if (stateMatches(changed, desired)) return response;
          var sections = Array.isArray(body.sections) ? body.sections : null;
          return reconcile(changed, desired, sections).then(function (result) {
            if (!result) return response;
            var merged = {};
            for (var key in changed) merged[key] = changed[key];
            if (result.items && !result.token) {
              merged.sections = result.sections || changed.sections;
            } else {
              for (var field in result) merged[field] = result[field];
            }
            return responseWith(response, merged);
          });
        })
        .catch(function () {
          return response;
        });
    });
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === "string" ? input : input.url;
      var pathname = new URL(url, window.location.origin).pathname;
      if (!giftRequestActive) {
        if (pathname === "/cart/add" || pathname === "/cart/add.js") {
          return interceptAdd(input, init);
        }
        if (
          pathname === "/cart/change" ||
          pathname === "/cart/change.js" ||
          pathname === "/cart/update" ||
          pathname === "/cart/update.js"
        ) {
          return interceptChange(input, init, pathname);
        }
      }
    } catch (e) {}
    return nativeFetch(input, init);
  };

  var syncing = false;
  var pending = false;

  function sync() {
    if (syncing) {
      pending = true;
      return;
    }
    syncing = true;

    fetchCart()
      .then(function (fetched) {
        return ensureAttribute(fetched, sectionNames());
      })
      .then(function (outcome) {
        var cart = outcome.cart;
        cartState = cart;
        var desired = desiredFor(subtotalOf(cart));
        noteDismissals(cart, desired);
        if (stateMatches(cart, desired)) return outcome.data;
        return reconcile(cart, desired, sectionNames());
      })
      .then(function (result) {
        if (!result) return;
        renderSections(result);
        document.dispatchEvent(new CustomEvent("cart:updated"));
      })
      .catch(function (error) {
        giftRequestActive = false;
        report("gwp_sync", error);
      })
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          sync();
        }
      });
  }

  var debounceTimer = null;

  function queueSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 300);
  }

  function start() {
    sync();
    document.addEventListener("cart:updated", queueSync);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
